export default __webpack_public_path__ + "static/media/school.cd7119c4.jpg";